import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';

export interface RequiredDocumentDTO {
  documentType: string;
  documentDescription: string;
}

export interface ApplicantOptionsDTO {
  firstName: string;
  lastName: string;
  acceptableDocumentsByCategory: {
    categoryDescription: string;
    acceptableDocuments: RequiredDocumentDTO[];
  }[];
}

export interface RequiredDocsDTO {
  managedAccountId: string;
  primaryApplicantOptions: ApplicantOptionsDTO | null;
  secondaryApplicantOptions: ApplicantOptionsDTO | null;
}

interface FetcherParams {
  clientId: string;
  accountId: string;
}

const fetchRequiredDocs = async ({
  accountId,
  clientId,
}: FetcherParams): Promise<RequiredDocsDTO> => {
  return authFetch(
    urlWithParams('/Adviser/ManagedAccountInvestigation/GetRequiredDocuments', {
      clientId,
      id: accountId,
    }),
  );
};

interface QueryParams {
  clientId: string;
  accountId: string;
}

export const useRequiredDocsQuery = ({ clientId, accountId }: QueryParams) => {
  return useQuery(
    queryKeys.requiredDocuments(clientId, accountId),

    () => fetchRequiredDocs({ clientId, accountId }),

    { cacheTime: 0 },
  );
};
